import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class VrService {
    constructor(
        private httpService: HttpService) { }

    //获取vr是否开启
    //TQQ 2018-01-24
    getVRisOpen() {
        var url = AppConfig.GetProdUrl() + '/VedioRacing/VRisOpen';
        return this.httpService.post(url, null);
    }

    //跳转vr页面
    //TQQ 2018-01-25
    openVr(channelId = 0) {
        var url = AppConfig.GetProdUrl() + '/VedioRacing/Logon';
        return this.httpService.get(url, { channelId: channelId });
    }

    //vr游戏记录
    //TQQ 2018-01-25
    getBetReport(params) {
        var url = AppConfig.GetProdUrl() + '/VedioRacing/GetBetReport';
        return this.httpService.post(url, params);
    }

    //vr追号记录
    //TQQ 2018-01-25
    getBetChaseReport(params) {
        var url = AppConfig.GetProdUrl() + '/VedioRacing/GetBetChaseReport';
        return this.httpService.post(url, params);
    }

    //vr盈亏记录
    //TQQ 2018-01-25
    getPlayerReport(params) {
        var url = AppConfig.GetProdUrl() + '/VedioRacing/GetPlayerReport';
        return this.httpService.post(url, params);
    }

    //vr帐变记录
    //TQQ 2018-01-25
    getAccountChangeReport(params) {
        var url = AppConfig.GetProdUrl() + '/VedioRacing/GetAccountChangeReport';
        return this.httpService.post(url, params);
    }

    //根据追号id获取订单详情列表
    //TQQ 2018-02-26
    getBetReportByChase(params) {
        var url = AppConfig.GetProdUrl() + '/VedioRacing/GetBetReportByChase';
        return this.httpService.post(url, params);
    }

    //获取vr帐变类别
    //TQQ 2018-01-26
    getChangeTypes() {
        var url = AppConfig.GetProdUrl() + '/VedioRacing/GetChangeTypes';
        return this.httpService.get(url);
    }

    //登录ug体育
    //TQQ 2018-06-12
    loginUg(webtype = 'Smart') {
        let url = AppConfig.GetProdUrl() + "/Ug/LoginUg";
        return this.httpService.get(url, { webType: webtype });
    }


}


// WEBPACK FOOTER //
// ./src/services/vr.service.ts